"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Easings are taken from: https://gist.github.com/gre/1650294.
 */
var EASINGS = {
    easeInOutCubic: function (t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
};
/**
 * This class is used for creating an animation with an easing.
 */
var EasingAnimation = /** @class */ (function () {
    function EasingAnimation() {
        this.startValue = 0; // Start value
        this.endValue = 20; // End value
        this.easingType = 'easeInOutCubic'; // Type of easing
        this.animationDuration = 500; // Animation duration in ms
        this.frameInterval = 20; // Min time between frames in ms
        this.isRunning = false;
        this.frames = null;
        this.value = 0;
        this.animationStartTime = 0;
        this.lastFrame = 0;
        this.animationFrameId = null;
        this.events = {
            frame: [],
            end: []
        };
        this.callback = function () {
            // Do nothing
        }; // Callback to be called between each iteration
    }
    /**
     * Adds an event listener.
     *
     * @param eventName Event name (frame, end).
     * @param callback Callback to be called.
     */
    EasingAnimation.prototype.on = function (eventName, callback) {
        this.events[eventName].push(callback);
    };
    /**
     * Removes an event listener.
     *
     * @param eventName Event name (frame, end).
     * @param callback Callback to be called.
     */
    EasingAnimation.prototype.off = function (eventName, callback) {
        var index = this.events[eventName].indexOf(callback);
        if (index > -1) {
            this.events[eventName].splice(index, 1);
        }
    };
    /**
     * Triggers an event.
     *
     * @param eventName Event name (frame, end).
     * @param data Data to send to the callback.
     */
    EasingAnimation.prototype.trigger = function (eventName, data) {
        for (var _i = 0, _a = this.events[eventName]; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(data);
        }
    };
    /**
     * Starts the animation.
     */
    EasingAnimation.prototype.start = function () {
        cancelAnimationFrame(this.animationFrameId);
        this.isRunning = true;
        this.value = this.startValue;
        this.animationStartTime = performance.now();
        this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
    };
    /**
     * Stops the animation.
     */
    EasingAnimation.prototype.stop = function () {
        if (this.isRunning) {
            this.isRunning = false;
            cancelAnimationFrame(this.animationFrameId);
            this.trigger('end', this.value);
        }
    };
    /**
     * Calculate eased value, from start value to end value, based on percent of progress.
     *
     * @param startValue Initial value for easing.
     * @param endValue Final value for easing.
     * @param progress Progress of animation [0 to 1].
     * @returns New value based on easing and progress.
     */
    EasingAnimation.prototype.calculateValue = function (startValue, endValue, progress) {
        var newValue = 0;
        if (startValue < endValue) {
            newValue = startValue + (endValue - startValue) * EASINGS.easeInOutCubic(progress);
        }
        else {
            newValue = startValue - (startValue - endValue) * EASINGS.easeInOutCubic(progress);
        }
        if (startValue === Math.round(startValue) && endValue === Math.round(endValue)) {
            newValue = Math.round(newValue);
        }
        if (progress > 1) {
            newValue = endValue;
        }
        return newValue;
    };
    /**
     * Animation frame - callback passed to rAF.
     *
     * @param now Current time when rAF start to fire callback.
     */
    EasingAnimation.prototype.animate = function (now) {
        var animationElapsedTime = now - this.animationStartTime;
        var frameElapsedTime = now - this.lastFrame;
        this.value = this.calculateValue(this.startValue, this.endValue, animationElapsedTime / this.animationDuration);
        if (animationElapsedTime > this.animationDuration) {
            this.trigger('frame', this.endValue);
            this.stop();
        }
        else {
            this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
            if (frameElapsedTime > this.frameInterval) {
                this.trigger('frame', this.value);
                this.lastFrame = now - (frameElapsedTime % this.frameInterval);
            }
        }
    };
    return EasingAnimation;
}());
exports.default = EasingAnimation;
//# sourceMappingURL=EasingAnimation.js.map